<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="row">
    <div class="col-12">
      <p-calendar
        formControlName="endDate"
        inputValidator
        label="RESIDENTS.END_DATE"
        inputStyleClass="form-control"
        [placeholder]="'RESIDENTS.END_DATE' | translate"
      ></p-calendar>
    </div>
  </div>
  <div class="text-end d-flex justify-content-end gap-2 mt-3">
    <p-button [disabled]="form.invalid || isPending()" styleClass="btn btn-primary d-flex" [loading]="isPending()" type="submit" [label]="'RESIDENTS.WITHDRAW'|translate"></p-button>
    <button class="btn btn-soft-primary" (click)="cancel()" type="button">{{ 'CANCEL' | translate }}</button>
  </div>
</form>
